<template>
  <div id="invoiceDetail">
    <el-card
      v-if="invoice"
      class="mainCard detailCard"
      :style="{width: dialogWidth}"
    >
      <!-- Header -->
      <div class="header">
        <section>
          <div>
            {{ invoice.invoice_detail.name }}
          </div>
          <div>
            Address:
            <span>
              {{ invoice.invoice_detail.address_line1 }}
            </span>
          </div>
          <div v-if="invoice.invoice_detail.address_line2">
            {{ invoice.invoice_detail.address_line2 }}
          </div>
          <div>
            <span>
              {{ invoice.invoice_detail.location_data.city_name }},
            </span>
            <span>
              {{ invoice.invoice_detail.location_data.region_name }}
            </span>
          </div>
          <div>
            {{ invoice.invoice_detail.location_data.country_name }}
          </div>
          <div v-if="invoice.invoice_detail.postal_code">
            {{ invoice.invoice_detail.postal_code }}
          </div>
          <div>
            Tel: {{ invoice.invoice_detail.phone_number }}
          </div>
          <div v-if="invoice.email">
            Email: {{ invoice.email }}
          </div>
        </section>
      </div>

      <!-- Contents -->
      <div class="content">
        <!-- Section 1 -->
        <section>
          <div>
            Date: {{ invoice.invoice_date }}
          </div>
          <div v-if="invoice.optional_id">
            Coach Invoice Number: {{ invoice.optional_id }}
          </div>
          <div>
            GCG Invoice Number: {{ invoice.id }}
          </div>
        </section>

        <!-- Section 2 -->
        <section>
          <div>Global Coach Group (International) Limited</div>
          <div>Attn: Finance Department</div>
          <div>
            17th Fl, Glenealy Tower, 1 Glenealy, Central, Hong Kong
          </div>
        </section>

        <!-- Section 3 -->
        <section>
          <div>
            Ref: Professional Services
          </div>
        </section>

        <!-- Section 4 -->
        <section>
          <h3>INVOICE & ORDER CONFIRMATION</h3>
        </section>

        <!-- Section 5 -->
        <section>
          <div>
            Dear Finance Department,
          </div>
        </section>

        <section>
          <div>
            I herewith provide you with my invoice under the following terms and conditions:
          </div>
        </section>

        <section>
          <DetailTable
            :invoice.sync="invoice"
          />
        </section>

        <section
          class="flexSection"
        >
          <div class="leftLabel">
            <div>Payment terms:</div>
          </div>
          <div class="right">
            <ul class="noneMargin">
              <li>30 days End of Month after receipt of invoice</li>
              <li>Bank transfer</li>
              <li>
                Please note that such transfers are based on 'Division of charges'.
                This means that banking fees incurred for international transfers at
                our end are borne by us.
                And all other banking fees that your bank charges are to be borne by you,
                the beneficiary.
                Depending on the bank that you are using this
                might include intermediary banking charges
                if your bank uses intermediaries for such international transfers.
              </li>
            </ul>
          </div>
        </section>

        <section
          class="flexSection"
        >
          <div class="leftLabel">
            <div>Beneficiary</div>
          </div>

          <div class="right">
            <ul class="flexList">
              <li>
                <div>Bank account name</div>
                <div v-if="invoice.invoice_detail.is_beneficiary_same">
                  {{ invoice.invoice_detail.name }}
                </div>
                <div v-else>
                  {{ formattedBeneficiary.name }}
                </div>
              </li>
              <li>
                <div>Beneficiary address</div>
                <div v-if="invoice.invoice_detail.is_beneficiary_same">
                  {{ invoice.invoice_detail.address_line1 }}
                  {{ invoice.invoice_detail.address_line2
                    ? invoice.invoice_detail.address_line2 : '' }}
                </div>
                <div v-else>
                  {{ formattedBeneficiary.address_line1 }}
                  {{ formattedBeneficiary.address_line2 !== '-'
                    ? formattedBeneficiary.address_line2 : '' }}
                </div>
              </li>
              <li>
                <div>Beneficiary country</div>
                <div v-if="invoice.invoice_detail.is_beneficiary_same">
                  {{ invoice.invoice_detail.location_data.country_name }}
                </div>
                <div v-else>
                  {{ formattedBeneficiary.location_data.country_name }}
                </div>
              </li>
              <li>
                <div>Beneficiary Postal / Zip Code</div>
                <div v-if="invoice.invoice_detail.is_beneficiary_same">
                  {{ invoice.invoice_detail.postal_code }}
                </div>
                <div v-else>
                  {{ formattedBeneficiary.postal_code }}
                </div>
              </li>
              <li>
                <div>Bank name</div>
                <div>{{ formattedBank.name }}</div>
              </li>
              <li>
                <div>Bank address</div>
                <div>
                  {{ formattedBank.address_line1 }}
                  {{ formattedBank.address_line2 !== '-'
                    ? formattedBank.address_line2 : '' }}
                </div>
              </li>
              <li>
                <div>Bank country</div>
                <div>{{ formattedBank.location_data.country_name }}</div>
              </li>
              <li>
                <div>Bank Postal / Zip Code</div>
                <div>{{ formattedBank.postal_code ? formattedBank.postal_code : '-' }}</div>
              </li>
              <li>
                <div>Account number</div>
                <div>{{ formattedBank.account_number }}</div>
              </li>
              <li>
                <div>Bank SWIFT code</div>
                <div>{{ formattedBank.swift_code }}</div>
              </li>
              <li v-if="formattedBank.iban">
                <div>IBAN</div>
                <div>{{ formattedBank.iban }}</div>
              </li>
            </ul>
          </div>
        </section>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import api from '@/api';
import DialogSetting from '@/mixins/dialog';
import DetailTable from './widgets/DetailTable.vue';

export default {
  components: {
    DetailTable,
  },

  mixins: [DialogSetting],

  data: () => ({
    invoice: null,
  }),

  computed: {
    ...mapState({
      user: (state) => state.user.user,
    }),

    roleType() {
      let role = '';
      if (this.user) {
        role = this.user.role_type;
      }
      return role;
    },

    formattedBeneficiary() {
      const object = {
        name: '-',
        address_line1: '-',
        address_line2: '-',
        postal_code: '-',
        location: {
          country_name: '-',
        },
      };

      if (this.invoice && this.invoice.invoice_detail.beneficiary) {
        Object.keys(this.invoice.invoice_detail.beneficiary).forEach((key) => {
          if (key === 'location') {
            object.location = this.invoice.invoice_detail.beneficiary[key];
          } else {
            object[key] = this.invoice.invoice_detail.beneficiary[key];
          }
        });
      }

      return object;
    },

    formattedBank() {
      const object = {
        name: '-',
        address_line1: '-',
        address_line2: '-',
        account_number: '-',
        swift_code: '-',
        postal_code: '-',
        iban: '',
        location: {
          country_name: '-',
        },
      };

      if (this.invoice && this.invoice.invoice_detail.bank_detail) {
        Object.keys(this.invoice.invoice_detail.bank_detail).forEach((key) => {
          if (key === 'location') {
            object.location = this.invoice.invoice_detail.bank_detail[key];
          } else {
            object[key] = this.invoice.invoice_detail.bank_detail[key];
          }
        });
      }

      return object;
    },
  },

  async created() {
    try {
      await this.fetchCurrentUser();
    } catch (err) {
      await this.$router.push({
        name: '404',
      });
    }

    if (this.$route.params.id) {
      this.getDetail(this.$route.params.id);
    }
  },

  methods: {
    ...mapActions('user', [
      'fetchCurrentUser',
    ]),

    async getDetail(id) {
      try {
        let response;
        if (this.roleType === 'coach') {
          response = await api.getCoachInvoiceDetail(id);
        } else if (this.roleType === 'MAM') {
          response = await api.getCoachInvoiceDetailMAM(id);
        } else {
          await this.$router.push({
            name: '404',
          });
        }

        if (response) {
          this.invoice = response.data;
        }
      } catch (err) {
        console.log(err);
        if (err.msg) {
          this.$message.error(err.msg);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  #invoiceDetail {
    padding: 25px 0;

    .detailCard {
      margin: 20px auto;

      .header {
        width: 100%;
        text-align: right;
      }

      section {
        margin: 15px 0;

        &.flexSection {
          display: flex;

          .leftLabel {
            width: 135px;
          }

          .right {
            width: calc(100% - 135px);
          }

          .noneMargin {
            margin: 0;
          }
        }

        h3 {
          text-align: center;
        }

        div {
          padding: 4px 0;
        }

        ul {
          list-style: none;
          padding: 0 0 0 10px;

          li {
            padding: 4px 0;

            &::before {
              content: '-';
              padding: 0 4px;
            }
          }

          &.flexList {
            li {
              display: flex;

              div {
                width: 50%;
                padding: 0 4px 0 0;
                box-sizing: border-box;
              }
            }
          }
        }
      }
    }
  }
</style>

<style lang="scss">
  @media print {
    #app,
    .dashGround {
      background: white !important;
    }

    #invoiceDetail {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      margin: 0 20px;

      .detailCard {
        width: 100%;
        line-height: 12px;
        box-shadow: none;
        border: none;
        font-size: 12px;
      }
    }
  }

  #invoiceDetail {
    @page {
      size: a4;
    }
  }
</style>
